import React, {useState, useEffect} from 'react'
import styled from 'styled-components';

const GroupTitle = styled.h5`

`

const Group = styled.div`
  margin-bottom: 20px;
`

const ColorBlock = props => {
  return (
    <ColorBlockContainer>
      <ColorBox color={props.color}/>
      <ColorDescription>{props.text}</ColorDescription>
    </ColorBlockContainer>);
};

const ColorBlockContainer = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
`;
const ColorDescription = styled.span`
  margin-left: 20px;
`;

const ColorBox = styled.span`
  width: 25px;
  height: 25px;
  border: 1px solid black;
  display: inline-block;
  background: ${props => props.color}
`;

export default props => {
  const {
    shapeFiles,
    tiffFiles
  } = props;

  const [legendItems, setLegendItems] = useState([]);

  useEffect(() => {
    let legendItems = [];

    [...shapeFiles,...tiffFiles].forEach(mapLayer => {
      if (mapLayer.legend) {
        legendItems.push({
          title: mapLayer.title,
          values: mapLayer.legend
        });
      }
    });

    setLegendItems(legendItems);

  }, [shapeFiles]);

  return (<div>
    {legendItems.map((legendGroup, i) => {
      return (<Group key={i}>
        <GroupTitle dangerouslySetInnerHTML={{__html: legendGroup.title}} />
        {legendGroup.values.map((val, j) => {
          return <ColorBlock key={j} color={val.color} text={val.text}/>
        })}
      </Group>)
      }
    )}
  </div>)

}